import React from 'react'
import { useState } from 'react';
import axios from 'axios';
function AddCategorys() {
    const [name, setName] = useState(''); 
    const [code, setCode] = useState('');
    const [active, setActive] = useState(true);
    const sendData =  async (e) =>{
        try {
            e.preventDefault();
          const formData = new FormData();
            formData.append('Name', name);
            formData.append('Code', code);
            formData.append('Active', active);
            const response = await axios.post(process.env.REACT_APP_API_URL+'/api/Category', formData)
            console.log(response);
            window.location.href = "/categories";
        } catch (error) {
          console.error(error);
        }
      };
  return (
    <>
     <div className='flex justify-center'>
                    <form  className='bg-white w-1/2 ' onSubmit={sendData} >
                        <h1 className="text-2xl font-semibold text-gray-900">Add Category</h1>
                        <div className="flex flex-col">
                        <label
                            htmlFor="brand"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Category
                        </label>
                        <input
                            type="text"
                            name="brand"
                            id="brand"
                            autoComplete="brand"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setName(e.target.value)}
                            placeholder='Enter Category Name'
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="code"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Code
                        </label>
                        <input
                            type="text"
                            name="code"
                            id="code"
                            autoComplete="code"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            placeholder='Enter Category Code'
                            onChange={(e)=>setCode(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Active
                        </label>
                        <select
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setActive(e.target.value)}
                        >
                            <option value="true">Active</option>
                            <option value="false">Disabled</option>
                        </select>
                        </div>
                        <button
                        type="submit"
                        className="mt-4 rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                        >
                        Add Category
                        </button>
                    </form>
                </div>
    </>
  )
}

export default AddCategorys